import createLucideIcon from '../createLucideIcon';

const Mouse = createLucideIcon('Mouse', [
  [
    'rect',
    { width: '12', height: '18', x: '6', y: '3', rx: '6', key: '1xb4cm' },
  ],
  ['path', { d: 'M12 7v4', key: 'xawao1' }],
]);

export default Mouse;
